import { InjectionToken } from '@angular/core';

export interface EventsModuleConfig {
  eventSendIntervalMilliseconds: number;
  isSendEnabled: boolean;
  maxBatchSize: number;
  maxRetryCount: number;
}

export const EVENT_SEND_INTERVAL_MS = new InjectionToken<number>(
  'app.events.sendIntervalMilliseconds',
);

export const EVENT_SERVICE_MAX_BATCH_SIZE = new InjectionToken<number>(
  'app.events.maxBatchSize',
);

export const EVENT_SERVICE_SEND_ENABLED = new InjectionToken<boolean>(
  'app.events.isSendEnabled',
);

export const EVENT_SERVICE_MAX_RETRY_COUNT = new InjectionToken<number>(
  'app.events.maxRetryCount',
);
